export default "__VITE_ASSET__LOQAUb8i__"